import {
	Box,
	Button,
	Card,
	CardContent,
	CardHeader,
	Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

export const BravoPage = () => {
	const navigate = useNavigate();

	return (
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			minHeight="80vh"
			bgcolor="background.default"
			px={2}
		>
			<Card sx={{ maxWidth: 500, textAlign: "center", p: 2 }}>
				<CardHeader
					title="🎉 Welcome!"
					titleTypographyProps={{ variant: "h4", align: "center" }}
				/>
				<CardContent>
					<Typography variant="body1" gutterBottom>
						Your form was created successfully.
					</Typography>
					<Typography variant="body2" color="text.secondary" gutterBottom>
						You can now edit the form, create more, or start collecting
						responses.
					</Typography>

					<Box mt={3} display="flex" justifyContent="center" gap={2}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => navigate("/app")}
						>
							Sign In
						</Button>
					</Box>
				</CardContent>
			</Card>
		</Box>
	);
};
